import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { user } from "../interfaces/user"
import { data } from "src/app/data";
@Injectable({
  providedIn: "root"
})
export class AuthService {
  private userlistener = new Subject<any>();
  constructor(private http: HttpClient, private router: Router) { }
  // #region auth
  signin(obj) {
    return new Promise((resolve, reject) => {
      this.http.post<{
        status: string,
        data: any
      }>(environment.apiurl + "auth/signin", obj)
        .subscribe(res => {
          resolve(res)
          // tslint:disable-next-line: triple-equals
          if (res.status == 'success') {
            data.loggedinuser = res.data;
            localStorage.setItem("user", JSON.stringify(data.loggedinuser));
            this.userlistener.next(data.loggedinuser)
          }
        })
    })
  }
  getuserlistener() {
    return this.userlistener.asObservable();
  }
  logout() {
    try{
      data.loggedinuser = null;
      localStorage.removeItem("user");
      this.userlistener.next(null);
      this.router.navigate(['/'])
    }catch(ex){}
  }
  autoAuthUser() {
    try{
      const currentUser = JSON.parse(localStorage.getItem("user"));
      data.loggedinuser = currentUser;
      this.userlistener.next(data.loggedinuser);
      setTimeout(()=>{
        this.userlistener.next(data.loggedinuser);
      },1000)
    }catch(ex){
    }
  }
  register(data) {
    return new Promise((resolve, reject) => {
      this.http.post<{
        status: string,
        data: any
      }>(environment.apiurl + "auth/signup", data)
        .subscribe(res => {
          resolve(res)
        })
    })
  }
  forgotpassword(data) {
    return new Promise((resolve, reject) => {
      this.http.post<{
        status: string,
        data: any
      }>(environment.apiurl + "auth/forgotpassword", data)
        .subscribe(res => {
          resolve(res)
        })
    })
  }
  updateprofile(obj) {
    return new Promise((resolve, reject) => {
      this.http.post<{
        status: string,
        data: any
      }>(environment.apiurl + "auth/updateprofile", obj)
        .subscribe(res => {
          resolve(res)
          if (res.status == 'success') {
            data.loggedinuser = res.data;
            localStorage.setItem("user", JSON.stringify(data.loggedinuser));
            this.userlistener.next(data.loggedinuser)
          }
        })
    })
  }
  updateprofileimage(obj) {
    return new Promise((resolve, reject) => {
      this.http.post<{
        status: string,
        data: any
      }>(environment.apiurl + "auth/updateprofileimage", obj)
        .subscribe(res => {
          resolve(res)
          if (res.status == 'success') {
            data.loggedinuser.image = res.data;
            localStorage.setItem("user", JSON.stringify(data.loggedinuser));
            this.userlistener.next(data.loggedinuser)
          }
        })
    })
  }
  // #endregion auth
}
